export default __webpack_public_path__ + "static/media/company-menu.2e3ae2a3.svg";